
import { defineComponent } from 'vue';
import HTTP from '@/config/axios-instance';
import AutobookingForm from '@/components/autobooking-form/AutobookingForm.vue';
import OtherForm from '@/components/autobooking-form/OtherForm.vue';
import CategoryTabs from '@/components/autobooking-form/CategoryTabs.vue';
import { SelectComponentItem, RepairReasonCategory } from '@/utils/interfaces';

export default defineComponent({
  name: 'AutobookingFormWidget',
  components: { AutobookingForm, OtherForm, CategoryTabs },
  props: {
    dataMechanicId: {
      type: Number,
      default: 0
    },
    dataWebColumns: {
      type: Number,
      default: 3
    },
    dataInitialDate: {
      type: String,
      default: ''
    },
    dataInitialService: {
      type: String,
      default: ''
    },
    dataSlotsInterval: {
      type: Number,
      default: 0
    },
    dataNoClientParts: {
      type: Number,
      default: 0
    },
    dataServiceCategoryUuid: {
      type: String,
      default: ''
    },
    dataBrand: {
      type: String,
      default: ''
    },
    dataBrandId: {
      type: String,
      default: ''
    },
    dataModel: {
      type: String,
      default: ''
    },
    dataModelId: {
      type: String,
      default: ''
    },
    dataShowOtherForm: {
      type: String,
      default: 'true'
    },
    dataMechanicMeta: {
      type: String,
      default: ''
    },
    dataBookowarkaFlow: {
      type: String,
      default: ''
    },
    dataFullAutobookingSupport: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      repairReasons: [] as RepairReasonCategory[],
      repairReasonId: '' as string,
      otherRepairsId: '812a98c9-50c3-472a-8c09-e1395d3cce29' as string,
      initialCategoryId: '' as string,
      isDataLoaded: false
    };
  },
  computed: {
    services(): SelectComponentItem[] {
      const repairReason = this.repairReasons.find(reason => reason.id === this.repairReasonId);
      if (!repairReason || this.otherRepairsId === this.repairReasonId) return [];

      const rr = repairReason.items?.map((item: any) => {
        return {
          key: item.id,
          text: item.text
        };
      }) || [];

      rr.unshift({
        key: 'disabled',
        text: 'Wybierz usługę'
      });

      return rr;
    }
  },
  async mounted() {
    await this.GETrepairReasons();
    this.isDataLoaded = true;
    if (!this.repairReasons.length) return;
    this.setInitialRepairReasonId();
    this.setInitialCategoryId();
  },
  methods: {
    async GETrepairReasons(): Promise<void> {
      const { data } = await HTTP(`/api_autobooking/services/${this.dataMechanicId}.json`);
      this.repairReasons = [...this.repairReasons, ...data];
    },
    changeReason(repairReasonId: string): void {
      this.repairReasonId = repairReasonId;
    },
    setInitialRepairReasonId(): void {
      if (!this.repairReasonId && this.dataInitialService) {
        const category = this.repairReasons.find((e: any) => e.items.find((i: any) => i.id === this.dataInitialService));
        if (category) this.repairReasonId = category.id;
      } else if (!this.repairReasonId && this.dataServiceCategoryUuid) {
        this.repairReasonId = this.dataServiceCategoryUuid;
      } else {
        this.repairReasonId = this.repairReasons[0].id;
      }
    },
    setInitialCategoryId(): void {
      this.initialCategoryId = this.repairReasonId;
    }
  }
});
